// extracted by mini-css-extract-plugin
module.exports = {"row":"bike-batch_row__3hOQ7","loadingOverlay":"bike-batch_loadingOverlay__10jTq","removeButton":"bike-batch_removeButton__1_ohY"};